<template>
  <div>
    <section-title content="Seleccione Sección(es)" has-line />
    <div class="row">
      <div class="col-12 col-md-6 col-lg-4 border-right">
        <validation-observer ref="form">
          <validation-provider v-slot="{ errors }" rules="required">
            <custom-drop-down
              v-model="section"
              label="Secciones:"
              fieldkey="id"
              fieldname="description"
              placeholder="Seleccione"
              custom-error-msg="La sección es requerida."
              :error="errors[0]"
              :options="sectionOptions"
              :disabled="readOnly"
            />
          </validation-provider>

          <div class="d-flex justify-content-end">
            <action-button
              i="fas fa-file-plus"
              text="Añadir"
              variant="success mt-2"
              @click="add"
            />
          </div>
        </validation-observer>
      </div>
      <div class="col-12 col-md col-lg">
        <label class="data-name">Seleccionado(s):</label>
        <draggable
          class="d-flex flex-wrap"
          :list="model"
          :disabled="readOnly"
          @end="organize"
        >
          <section-item
            v-for="item in model"
            :key="item.id"
            :data="item"
            draggable
            @remove="remove"
          />
        </draggable>
      </div>
    </div>
  </div>
</template>

<script>
import SectionTitle from 'SectionTitle';
import CustomDropDown from 'custom-drop-down';
import ActionButton from 'ActionButton';
import Draggable from 'vuedraggable';
import { ValidationProvider, ValidationObserver } from 'vee-validate';

import SectionItem from './SectionItem.vue';

import { getTypes } from '@/services/operations/dashboard-management';

export default {
  name: 'Sections',
  components: {
    SectionTitle,
    CustomDropDown,
    ActionButton,
    ValidationProvider,
    ValidationObserver,
    Draggable,
    SectionItem,
  },
  props: {
    value: {
      type: Array,
      default: () => [],
    },
    readOnly: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    section: null,
    sections: [],
  }),
  async mounted() {
    await this.getSections();
  },
  computed: {
    model: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
    sectionOptions() {
      return this.sections
        .filter((x) => !this.model.map((y) => y.id).includes(x.id))
        .sort((a, b) =>
          a.description.localeCompare(b.description, undefined, {
            sensitivity: 'base',
          })
        );
    },
  },
  methods: {
    async getSections() {
      const { data } = await getTypes({ onlyDashboardMaintainable: false });
      this.sections = data;
    },
    async add() {
      const validator = this.$refs.form;
      const isValid = await validator.validate();
      if (!isValid) return;

      this.model.push({ ...this.section, order: this.model.length + 1 });
      this.organize();
      this.section = null;
      validator.reset();
    },
    remove(item) {
      const index = this.model.indexOf(item);
      this.model.splice(index, 1);
      this.organize();
    },
    organize() {
      this.model.forEach((x, i) => (x.order = i + 1));
    },
  },
};
</script>

<style lang="scss" scoped>
.w-content {
  width: fit-content;
}
.grab {
  cursor: grab;
}
.dot {
  width: 15px;
  height: 15px;
}
.pointer {
  cursor: pointer;
}
</style>
